(function () {
  if (customElements.get('sticky-atc')) return;

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.init.bind(this), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      this.pill = this.querySelector('.sticky-atc');
      this.button = this.querySelector('[data-sticky-atc-button]');
      this.label = this.querySelector('[data-sticky-atc-label]');
      this.realButton = document.querySelector('.product-form__submit');
      this.sheet = this.querySelector('[data-sticky-atc-sheet]');

      // No buyable form (e.g. coming soon) -> no sticky bar at all.
      if (!this.pill || !this.button || !this.realButton) {
        this.remove();
        return;
      }

      if (this.sheet) {
        this.setupSheet();
      } else {
        this.button.addEventListener('click', function () {
          if (this.button.hasAttribute('disabled') || this.button.getAttribute('aria-disabled') === 'true') return;
          this.realButton.click();
        }.bind(this));
        this.syncButton();
        this.buttonObserver = new MutationObserver(this.syncButton.bind(this));
        this.buttonObserver.observe(this.realButton, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class']
        });
      }

      this.setupReveal();
      this.setupDrawerHide();
    }

    setupDrawerHide() {
      // Hide the bar while the MENU drawer is open (the cart drawer is already
      // handled via body.overflow-hidden, which the menu drawer does not set).
      var menuDrawer = document.querySelector('#Details-menu-drawer-container');
      if (!menuDrawer) return;
      var sync = function () {
        document.body.classList.toggle('sticky-atc-menu-open', menuDrawer.hasAttribute('open'));
      };
      this.menuObserver = new MutationObserver(sync);
      this.menuObserver.observe(menuDrawer, { attributes: true, attributeFilter: ['open'] });
      sync();
    }

    setupReveal() {
      // Reveal the pill only once the real Add to Cart button has scrolled
      // ABOVE the top of the viewport (the user is now below it).
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = entry.boundingClientRect.bottom <= 0;
          var show = !entry.isIntersecting && scrolledPast;
          // Same escape hatch the sheet got (see openSheet): body-level
          // third-party widgets (Google badge/PBar, chat) pin themselves at
          // max z-index, and equal z-index resolves by DOM order. The widgets
          // inject LATE (load+2.5s), so a one-time move at init loses the tie;
          // re-append on every show so the pill is last-in-body at the moment
          // it matters. Class-held refs survive moves (nodes, not paths).
          if (show && document.body.lastElementChild !== this.pill) {
            document.body.appendChild(this.pill);
            // Force a style flush so the slide-in transition still runs from
            // the hidden state: append + class-add in the same frame otherwise
            // skips the animation entirely (pill pops in, feels unresponsive).
            void this.pill.offsetWidth;
          }
          this.pill.classList.toggle('is-visible', show);
        }.bind(this));
      }.bind(this), { threshold: 0 });
      this.io.observe(this.realButton);
    }

    syncButton() {
      var realLabel = this.realButton.querySelector('span');
      var text = realLabel ? realLabel.textContent.trim() : '';
      if (text) this.label.textContent = text;
      var disabled = this.realButton.hasAttribute('disabled') || this.realButton.getAttribute('aria-disabled') === 'true';
      if (disabled) {
        this.button.setAttribute('disabled', 'disabled');
        this.button.setAttribute('aria-disabled', 'true');
      } else {
        this.button.removeAttribute('disabled');
        this.button.setAttribute('aria-disabled', 'false');
      }
    }

    /* ---------- Variant sheet ---------- */

    setupSheet() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-sticky-atc-variants]').textContent || '[]');
      } catch (e) {
        this.variants = [];
      }
      this.optionCount = parseInt(this.dataset.optionCount || '1', 10);
      this.selected = {};
      this.adding = false;
      this.querySelectorAll('.sticky-atc-opt').forEach(function (group) {
        var sel = group.querySelector('.sticky-atc-opt__pill.is-selected');
        if (sel) this.selected[sel.dataset.optionPosition] = sel.dataset.value;
      }.bind(this));

      this.sheetAdd = this.querySelector('[data-sticky-atc-sheet-add]');
      this.sheetAddLabel = this.querySelector('[data-sticky-atc-sheet-label]');
      this.sheetPrice = this.querySelector('[data-sticky-atc-sheet-price]');

      this.pills = Array.from(this.querySelectorAll('.sticky-atc-opt__pill'));
      this.pills.forEach(function (pill) {
        pill.addEventListener('click', this.onPillTap.bind(this, pill));
      }.bind(this));

      this.invItems = Array.from(this.querySelectorAll('[data-sticky-atc-inventory] [data-variant-id]'));

      // Close on the X button, on the overlay, or on any click outside the panel.
      this.sheet.addEventListener('click', function (e) {
        if (e.target.closest('.product-rating-link')) {
          // Rating link: close the sheet and let the document-level delegate
          // (product-custom.js) handle the scroll-to-reviews navigation. Do
          // NOT stopPropagation here — the event must keep bubbling to
          // document for that handler to fire.
          this.closeSheet();
          return;
        }
        if (e.target.closest('[data-sticky-atc-close]') || !e.target.closest('.sticky-atc-sheet__panel')) {
          this.closeSheet();
        }
      }.bind(this));

      this.sheetAdd.addEventListener('click', this.addSelected.bind(this));
      // Bind Escape on the SHEET, not on <sticky-atc>: openSheet() reparents the
      // sheet to <body>, so a handler on the custom element stops receiving key
      // events from inside the open dialog.
      this.sheet.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') this.closeSheet();
      }.bind(this));
      this.button.setAttribute('aria-expanded', 'false');
      if (!this.sheet.id) this.sheet.id = 'StickyAtcSheet';
      this.button.setAttribute('aria-controls', this.sheet.id);

      var anyAvailable = this.variants.some(function (v) { return v.available; });
      if (!anyAvailable) {
        this.button.setAttribute('disabled', 'disabled');
        this.label.textContent = this.dataset.labelSoldout;
      } else {
        this.button.addEventListener('click', this.openSheet.bind(this));
      }

      this.updateState();
    }

    findVariant() {
      var self = this;
      return this.variants.find(function (v) {
        for (var p = 1; p <= self.optionCount; p++) {
          if (self.selected[p] == null) return false;
          if (v['option' + p] !== self.selected[p]) return false;
        }
        return true;
      });
    }

    isValueAvailable(position, value) {
      var self = this;
      return this.variants.some(function (v) {
        if (!v.available) return false;
        if (v['option' + position] !== value) return false;
        for (var p = 1; p <= self.optionCount; p++) {
          if (p === position) continue;
          if (self.selected[p] != null && v['option' + p] !== self.selected[p]) return false;
        }
        return true;
      });
    }

    updateState() {
      var self = this;
      this.pills.forEach(function (pill) {
        var pos = parseInt(pill.dataset.optionPosition, 10);
        var val = pill.dataset.value;
        var available = self.isValueAvailable(pos, val);
        pill.classList.toggle('is-selected', self.selected[pos] === val);
        pill.classList.toggle('is-unavailable', !available);
        pill.setAttribute('aria-pressed', self.selected[pos] === val ? 'true' : 'false');
        if (available) {
          pill.removeAttribute('aria-disabled');
        } else {
          pill.setAttribute('aria-disabled', 'true');
        }
      });

      var variant = this.findVariant();
      this.showInventory(variant ? variant.id : null);
      if (variant && variant.available) {
        this.currentVariant = variant;
        if (!this.adding) this.sheetAdd.removeAttribute('disabled');
        this.sheetAddLabel.textContent = this.dataset.labelAdd;
        if (this.sheetPrice) this.renderPrice(variant);
      } else {
        this.currentVariant = null;
        this.sheetAdd.setAttribute('disabled', 'disabled');
        this.sheetAddLabel.textContent = variant ? this.dataset.labelSoldout : this.dataset.labelUnavailable;
        if (this.sheetPrice && variant) this.renderPrice(variant);
      }
    }

    showInventory(id) {
      if (!this.invItems) return;
      this.invItems.forEach(function (el) {
        el.hidden = String(el.dataset.variantId) !== String(id);
      });
    }

    onPillTap(pill) {
      if (pill.classList.contains('is-unavailable')) return;
      this.selected[pill.dataset.optionPosition] = pill.dataset.value;
      this.updateState();
    }

    // Inverse of findVariant(): given the MAIN form's current variant id, set
    // this.selected so the sheet opens pre-selected to what the shopper already
    // picked in the page's own variant picker. No-ops if the form or variant
    // can't be resolved (keeps the existing seed).
    syncFromMainForm() {
      var input = document.querySelector('product-form form[action*="/cart/add"] [name="id"]') ||
                  document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (!input) return;
      var vid = parseInt(input.value, 10);
      if (!vid || !this.variants) return;
      var match = null;
      for (var i = 0; i < this.variants.length; i++) {
        if (this.variants[i].id === vid) { match = this.variants[i]; break; }
      }
      if (!match) return;
      // findVariant() reads flat option1/option2/option3 fields (see PRE-STEP),
      // not an options[] array -- mirror that here.
      for (var p = 1; p <= this.optionCount; p++) {
        if (match['option' + p] != null) this.selected[p] = match['option' + p];
      }
    }

    openSheet() {
      if (this.button.hasAttribute('disabled')) return;
      // Mobile-only bar: never open the sheet on desktop (the bar is hidden there).
      if (getComputedStyle(this).display === 'none') return;
      // Move the sheet to the end of <body> so it sits above body-level
      // third-party widgets (chat, Google badge) that pin themselves at a
      // max z-index — equal z-index is broken by DOM order, last wins.
      document.body.appendChild(this.sheet);
      // The sheet's one-time server seed goes stale if the shopper changed the
      // variant in the main form after load -- re-seed from the live form so
      // the sheet always opens matching what they picked up-page.
      this.syncFromMainForm();
      this.mountOffer();
      this.updateState();
      this.sheet.classList.add('is-open');
      // A dialog must own the scroll: lock the page behind it. This also hides
      // the pill via the existing body.overflow-hidden rule (pill only -- the
      // sheet lives at body level and has its own classes).
      document.body.classList.add('overflow-hidden');
      this.button.setAttribute('aria-expanded', 'true');
      // Move focus into the dialog (aria-modal without focus management strands
      // keyboard/screen-reader users behind the overlay).
      var panel = this.sheet.querySelector('.sticky-atc-sheet__panel') || this.sheet;
      var closeBtn = this.sheet.querySelector('.sticky-atc-sheet__close');
      if (typeof trapFocus === 'function') {
        try { trapFocus(panel, closeBtn || panel); } catch (e) { if (closeBtn) closeBtn.focus(); }
      } else if (closeBtn) {
        closeBtn.focus();
      }
    }

    // Relocate the page's free-book offer into the sheet while it's open so
    // shoppers using the sticky bar can see and pick their free book. It is a
    // single DOM node (moved, not cloned) — there is no state to keep in sync.
    mountOffer() {
      var group = document.querySelector('[data-fbo-group]');
      if (!group || this.sheet.contains(group)) return;
      this.offerGroup = group;
      this.offerMarker = document.createComment('fbo-offer');
      group.parentNode.insertBefore(this.offerMarker, group);
      var host = this.sheet.querySelector('.sticky-atc-sheet__body') || this.sheet.querySelector('.sticky-atc-sheet__panel');
      if (host) host.appendChild(group);
    }

    unmountOffer() {
      if (this.offerGroup && this.offerMarker && this.offerMarker.parentNode) {
        this.offerMarker.parentNode.insertBefore(this.offerGroup, this.offerMarker);
        this.offerMarker.remove();
      }
      this.offerMarker = null;
    }

    closeSheet() {
      this.sheet.classList.remove('is-open');
      // Unlock the page. Safe on every close path: the add-success flow closes
      // the sheet BEFORE the cart drawer opens and re-locks with its own class add.
      document.body.classList.remove('overflow-hidden');
      this.unmountOffer();
      this.button.setAttribute('aria-expanded', 'false');
      // Release the focus trap and hand focus back to the trigger.
      if (typeof removeTrapFocus === 'function') {
        try { removeTrapFocus(this.button); } catch (e) { this.button.focus(); }
      } else {
        this.button.focus();
      }
    }

    addSelected() {
      if (this.adding) return;
      if (!this.currentVariant) return;
      var addVariantId = this.currentVariant.id;
      var self = this;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sections = '';
      try {
        sections = cart ? cart.getSectionsToRender().map(function (s) { return s.id; }).join(',') : '';
      } catch (e) {
        sections = '';
      }

      // Also add the offer book(s) selected in the sheet: free ones (not yet in
      // the cart) carry the _free_book property; any already in the cart are
      // added as full-price extras. One free book per add (freeCap = 1).
      var giftItems = (window.FreeBookOffer && window.FreeBookOffer.selectedGiftItems)
        ? window.FreeBookOffer.selectedGiftItems(1)
        : [];
      var items = [{ id: addVariantId, quantity: 1 }].concat(giftItems);
      var giftDropped = false;

      this.adding = true;
      var addPromise;
      try {
        this.sheetAdd.setAttribute('disabled', 'disabled');
        this.showSheetError('');

        var addItems = function (its) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: its, sections: sections, sections_url: window.location.pathname })
          }).then(function (r) { return r.json(); });
        };

        addPromise = addItems(items);
      } catch (e) {
        self.adding = false;
        self.updateState();
        self.showSheetError("Couldn't add to cart — please check your connection and try again.");
        return;
      }

      addPromise
        .then(function (json) {
          // If the combined add failed (e.g. a gift went out of stock), retry
          // with just the chosen variant so the product still gets added --
          // and remember to tell the shopper the book did not come along.
          if (json && json.status && giftItems.length) {
            giftDropped = true;
            return addItems([{ id: addVariantId, quantity: 1 }]);
          }
          return json;
        })
        .then(function (json) {
          self.adding = false;
          self.updateState();
          if (json && json.status) {
            // Used to return silently, leaving the sheet open with no feedback.
            self.showSheetError(json.description || json.message || 'Sold out — please pick another option.');
            return;
          }
          self.closeSheet();
          if (cart && json && json.sections) {
            if (window.FreeBookOffer) window.FreeBookOffer.markSelfSync();
            // Tell the drawer where focus came from so ITS close() can restore it.
            if (cart.setActiveElement) cart.setActiveElement(self.button);
            cart.renderContents(json);
            if (window.FreeBookOffer) {
              window.FreeBookOffer.fixEmptyState(cart, json);
              window.FreeBookOffer.syncFromCart();
            }
            if (giftDropped) {
              // Parity with the main-form path's showGiftError: the drawer just
              // rendered fresh, so write after the render or it gets wiped.
              // Routed through the shared qcartShowCartError (cart-drawer.js,
              // typeof-guarded) so this and the other three writers of
              // #CartDrawer-CartErrors share one timer instead of racing.
              var giftErrMsg = 'The storybook could not be added. Please try again from the product page.';
              if (typeof window.qcartShowCartError === 'function') {
                window.qcartShowCartError(giftErrMsg);
              } else {
                var giftErrEl = document.getElementById('CartDrawer-CartErrors');
                if (giftErrEl) giftErrEl.textContent = giftErrMsg;
              }
            }
            // Publish the FULL cart, not the partial /cart/add.js response —
          // subscribers like price-per-item read cartData.items as the whole
          // cart (free-book-offer.js established this exact pattern; the
          // extra fetch is the accepted cost of a correct event contract).
          if (window.publish) {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (full) { window.publish('cart-update', { source: 'sticky-atc', cartData: full }); })
              .catch(function () {});
          }
          } else {
            window.location = '/cart';
          }
        })
        .catch(function () {
          self.adding = false;
          self.updateState();
          self.showSheetError("Couldn't add to cart — please check your connection and try again.");
        });
    }

    showSheetError(message) {
      if (!this.sheet || !this.sheetAdd) return;
      var el = this.sheet.querySelector('.sticky-atc-sheet__error');
      if (!message) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'sticky-atc-sheet__error';
        el.setAttribute('role', 'alert');
        el.style.cssText = 'color:#b91c1c;margin:0.6rem 0 0;font-size:1.3rem;text-align:center;';
        this.sheetAdd.insertAdjacentElement('afterend', el);
      }
      el.textContent = message;
    }

    renderPrice(variant) {
      if (!this.sheetPrice) return;
      if (variant.compare_at && variant.compare_at > variant.price) {
        this.sheetPrice.innerHTML =
          '<s class="sticky-atc-sheet__was">' + this.formatMoney(variant.compare_at) + '</s> ' +
          '<span class="sticky-atc-sheet__now">' + this.formatMoney(variant.price) + '</span>';
      } else {
        this.sheetPrice.textContent = this.formatMoney(variant.price);
      }
    }

    formatMoney(cents) {
      try {
        var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: c }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    disconnectedCallback() {
      if (this.buttonObserver) this.buttonObserver.disconnect();
      if (this.io) this.io.disconnect();
      if (this.menuObserver) this.menuObserver.disconnect();
    }
  }

  customElements.define('sticky-atc', StickyAtc);
})();
